import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import MountGuideRegionGrid from '../../components/game/MountGuideRegionGrid';
import { useMountGuideHome } from '../../hooks/useMountGuideData';
import { guideText } from '../../utils/guideLocale';
import '../../styles/MountGuide.css';

const MountGuideHome: React.FC = () => {
    const { locale } = useLanguage();
    const { data, loading } = useMountGuideHome();
    const [search, setSearch] = useState('');

    const labels =
        locale === 'pt-BR'
            ? {
                  title: 'Índice',
                  subtitle:
                      'Companheiros por masmorra/região e outras categorias (desperto, limitado, loja, evolução).',
                  breadcrumbGuide: 'Guia do jogo',
                  breadcrumbMounts: 'Índice',
                  search: 'Buscar região…',
                  empty: 'Nenhuma região cadastrada ainda. O admin pode adicionar no painel.',
                  back: 'Voltar ao guia',
              }
            : {
                  title: 'Index',
                  subtitle: 'Companions that appear in each region/instance dungeon.',
                  breadcrumbGuide: 'Game guide',
                  breadcrumbMounts: 'Index',
                  search: 'Search region…',
                  empty: 'No regions yet. An admin can add them in the panel.',
                  back: 'Back to guide',
              };

    const showLoading = loading && !data;

    return (
        <div className="game-main-inner mount-guide-page">
            <nav className="mount-guide-breadcrumb" aria-label="Breadcrumb">
                <Link to="/game">{labels.breadcrumbGuide}</Link>
                <span aria-hidden>›</span>
                <span>{labels.breadcrumbMounts}</span>
            </nav>

            <div className="mount-guide-search">
                <input
                    type="search"
                    placeholder={labels.search}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    aria-label={labels.search}
                />
            </div>

            <h2 className="mount-guide-region-title">{labels.title}</h2>
            <p className="mount-guide-index-subtitle">{labels.subtitle}</p>

            {showLoading && (
                <p className="game-sidebar-muted">{locale === 'pt-BR' ? 'Carregando…' : 'Loading…'}</p>
            )}

            {data && (
                <>
                    {data.sections.map((section) => (
                        <section key={section.id}>
                            <div className="mount-guide-section-bar">
                                {guideText(locale, section.titleEn, section.titlePtBr)}
                            </div>
                            <MountGuideRegionGrid regions={section.regions} locale={locale} search={search} />
                        </section>
                    ))}

                    {data.ungroupedRegions.length > 0 && (
                        <section>
                            {data.sections.length > 0 && (
                                <div className="mount-guide-section-bar">
                                    {locale === 'pt-BR' ? 'Outras regiões' : 'Other regions'}
                                </div>
                            )}
                            <MountGuideRegionGrid regions={data.ungroupedRegions} locale={locale} search={search} />
                        </section>
                    )}

                    {data.sections.length === 0 && data.ungroupedRegions.length === 0 && (
                        <p className="mount-guide-empty">{labels.empty}</p>
                    )}
                </>
            )}

            <p style={{ marginTop: '2rem' }}>
                <Link to="/game" className="btn btn-outline btn-sm">
                    <i className="ri-arrow-left-line" /> {labels.back}
                </Link>
            </p>
        </div>
    );
};

export default MountGuideHome;
